import { axiosNoAuth, axiosAuth } from './instance';

const baseURL = 'https://api.intrigue.io/api/';

const noAuthGETRequest = async (endpoint, success, error) => {
  try {
    const response = await axiosNoAuth.get(baseURL + endpoint);
    console.log('response for public get req.', response);
    success(response);
  } catch (e) {
    console.log('error in public get req,', e);
    error(e);
  }
};

export const noAuthRequest = {
  get: noAuthGETRequest,
};

const unauthGETRequest = async (
  dispatch,
  endpoint,
  loading,
  success,
  error
) => {
  loading && dispatch(loading());

  try {
    const response = await axiosNoAuth.get(baseURL + endpoint);
    console.log('response for public get req.', response);
    if (success) {
      dispatch(success(response));
      return response.data
    } else {
      throw new Error(
        'Please define "success" action for redux to handle response'
      );
    }
  } catch (e) {
    console.log('error in private get req,', e);
    error && dispatch(error(e));
  }
};

const unauthPOSTRequest = async (
  dispatch,
  data,
  endpoint,
  loading,
  success,
  error
) => {
  loading && dispatch(loading());

  try {
    const response = await axiosAuth.post(baseURL + endpoint, data);
    console.log('response for public post req.', response);
    if (success) {
      dispatch(success(response));
    } else {
      throw new Error(
        'Please define "success" action for redux to handle response'
      );
    }
  } catch (e) {
    console.log('error in private post req,', e);
    error && dispatch(error(e));
  }
};

export const unAuthRequest = {
  get: unauthGETRequest,
  post: unauthPOSTRequest,
};

const authGETRequest = async (dispatch, endpoint, loading, success, error) => {
  loading && dispatch(loading());

  try {
    const response = await axiosAuth.get(baseURL + endpoint);
    console.log('response for private get req.', response);
    if (success) {
      dispatch(success(response));
    } else {
      throw new Error(
        'Please define "success" action for redux to handle response'
      );
    }
  } catch (e) {
    console.log('error in private get req,', e);
    error && dispatch(error(e));
  }
};

const authPOSTRequest = async (
  dispatch,
  data,
  endpoint,
  loading,
  success,
  error
) => {
  loading && dispatch(loading());

  try {
    const response = await axiosAuth.post(baseURL + endpoint, data);
    console.log('response for private post req.', response);
    if (success) {
      dispatch(success(response));
    } else {
      throw new Error(
        'Please define "success" action for redux to handle response'
      );
    }
  } catch (e) {
    console.log('error in private get req,', e);
    error && dispatch(error(e?.response?.data));
  }
};

const authDELETERequest = async (
  dispatch,
  endpoint,
  loading,
  success,
  error
) => {
  loading && dispatch(loading());

  try {
    const response = await axiosAuth.delete(baseURL + endpoint, {});
    console.log('response for private get req.', response);
    if (success) {
      dispatch(success(response));
    } else {
      throw new Error(
        'Please define "success" action for redux to handle response'
      );
    }
  } catch (e) {
    console.log('error in private get req,', e);
    error && dispatch(error(e));
  }
};

export const authRequest = {
  get: authGETRequest,
  post: authPOSTRequest,
  delete: authDELETERequest,
};

// REDUX Action creator helpers
export function actionStates(actionName) {
  if (typeof actionName !== 'string') {
    throw new Error('actionName must be a string');
  }
  const actionNameUpper = actionName.toUpperCase();
  const isLoading = `${actionNameUpper}_LOADING`;
  const success = `${actionNameUpper}_SUCCESS`;
  const error = `${actionNameUpper}_ERRORED`;
  const reset = `${actionNameUpper}_RESET`;

  return {
    isLoading,
    success,
    error,
    reset,
  };
}

export const actionLoading = (action) => () => {
  return {
    type: actionStates(action).isLoading,
    loading: true,
  };
};

export const actionSuccess = (action) => (data) => {
  return {
    type: actionStates(action).success,
    data,
  };
};

export const actionErrored = (action) => (error) => {
  return {
    type: actionStates(action).error,
    error,
  };
};

export const actionReset = (action) => () => {
  return {
    type: actionStates(action).reset,
  };
};
